'use strict';

exports.__esModule = true;
exports.RemoteModelInterface = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*eslint no-return-assign:0*/


var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _modelUtils = require('./modelUtils');

var modelUtils = _interopRequireWildcard(_modelUtils);

var _wSpyLog = require('./wSpyLog');

var _hooksManager = require('./RMIHooks/hooksManager');

var _repeaterUtils = require('./repeaterUtils/repeaterUtils');

var _repeaterUtils2 = _interopRequireDefault(_repeaterUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DATA = 'data';
var FULL_DATA = 'fullData';
var DESIGN = 'design';
var STATE = 'state';
var TYPE = 'type';
var PROPS = 'props';
var PARENT = 'parent';
var EVENTS = 'events';
var LAYOUT = 'layout';
var BEHAVIOR = 'behavior';
var PUBLIC_API = 'publicAPI';
var IS_DISPLAYED = 'isDisplayed';
var IS_GHOST = 'isGhost';
var STYLE = 'style';
var ID = 'id';
var CHILDREN = 'children';
var DISPLAYED_ONLY_COMPONENTS = 'displayedOnlyComponents';
var DISPLAYED_ROOT = 'displayedRoot';
var GLOBAL_SCOPE = 'GLOBAL_SCOPE';
var COMPONENT_SCOPE = 'COMPONENT_SCOPE';

var RemoteModelInterface = exports.RemoteModelInterface = function () {
  function RemoteModelInterface(modelJson, onUpdateCallback, options) {
    _classCallCheck(this, RemoteModelInterface);

    this._model = _lodash2.default.defaults(modelJson, {
      components: {},
      connections: {},
      componentsScopes: {},
      siteStructure: {},
      pageData: {},
      eventHandlers: {},
      EventTypes: {},
      appStudioWidgetData: { properties: {} },
      scopesHierarchy: [{ type: GLOBAL_SCOPE, id: GLOBAL_SCOPE, additionalData: {} }],
      renderType: 'bolt',
      appApis: {},
      seo: {
        title: '',
        structuredData: [],
        metaTags: [],
        links: [],
        statusCode: ''
      }
    });

    this._onUpdateCallback = onUpdateCallback;

    var optionsHookManager = _lodash2.default.get(options, '_hooksManager');
    var optionsTransaction = _lodash2.default.get(options, '_transaction');
    this._hooksManager = optionsHookManager ? optionsHookManager : new _hooksManager.HooksManager();
    this._transaction = optionsTransaction ? optionsTransaction : { _onTransaction: false, _transactionData: {} };
    this.controllerId = null;
  }

  RemoteModelInterface.prototype.addComponent = function addComponent(compId, compDescriptor, isGhost) {
    if (isGhost) {
      return addGhostComponent.call(this, compId, compDescriptor);
    }

    var comp = generateDefaultCompStructure();
    for (var key in comp) {
      //eslint-disable-line guard-for-in
      comp[key] = compDescriptor[key] || comp[key];
    }
    comp[PARENT] = compDescriptor[PARENT];
    comp[TYPE] = compDescriptor[TYPE];
    comp[ID] = compDescriptor[ID];
    comp[DISPLAYED_ROOT] = compDescriptor[DISPLAYED_ROOT];
    this._model.components[compId] = comp;
    this._model.componentsScopes[compId] = GLOBAL_SCOPE;
  };

  RemoteModelInterface.prototype.addSiteStructure = function addSiteStructure(siteStructureData) {
    this._model.siteStructure = siteStructureData;
  };

  RemoteModelInterface.prototype.addPageData = function addPageData(pageData) {
    this._model.pageData = pageData;
  };

  RemoteModelInterface.prototype.addConnections = function addConnections(connectionsModel) {
    _lodash2.default.defaultsDeep(this._model.connections, connectionsModel);
  };

  RemoteModelInterface.prototype.resetComponentsScope = function resetComponentsScope() {
    var _this = this;

    for (var compId in this._model.components) {
      //eslint-disable-line guard-for-in
      var displayedOnlyCompIds = this._model.components[compId].displayedOnlyComponents;

      displayedOnlyCompIds.forEach(function (displayedOnlyCompId) {
        return _this._model.componentsScopes[displayedOnlyCompId] = null;
      });
    }
  };

  RemoteModelInterface.prototype.addEventTypes = function addEventTypes(EventTypes) {
    this._model.EventTypes = EventTypes;
  };

  //Getters

  RemoteModelInterface.prototype.getComp = function getComp(compId) {
    return _lodash2.default.cloneDeep(_lodash2.default.get(this._model.components, compId));
  };

  RemoteModelInterface.prototype.getState = function getState(compId) {
    return _lodash2.default.cloneDeep(_lodash2.default.get(this._model.components, [compId, STATE]));
  };

  RemoteModelInterface.prototype.getData = function getData(compId) {
    return _lodash2.default.cloneDeep(_lodash2.default.get(this._model.components, [compId, DATA]));
  };

  RemoteModelInterface.prototype.getStyle = function getStyle(compId) {
    return _lodash2.default.cloneDeep(_lodash2.default.get(this._model.components, [compId, STYLE]));
  };

  RemoteModelInterface.prototype.getDesign = function getDesign(compId) {
    return _lodash2.default.cloneDeep(_lodash2.default.get(this._model.components, [compId, DESIGN]));
  };

  RemoteModelInterface.prototype.getType = function getType(compId) {
    return _lodash2.default.cloneDeep(_lodash2.default.get(this._model.components, [compId, TYPE]));
  };

  RemoteModelInterface.prototype.getProps = function getProps(compId) {
    return _lodash2.default.cloneDeep(_lodash2.default.get(this._model.components, [compId, PROPS]));
  };

  RemoteModelInterface.prototype.getEvents = function getEvents(compId) {
    return _lodash2.default.cloneDeep(_lodash2.default.get(this._model.components, [compId, EVENTS]));
  };

  RemoteModelInterface.prototype.getLayout = function getLayout(compId) {
    return _lodash2.default.cloneDeep(_lodash2.default.get(this._model.components, [compId, LAYOUT]));
  };

  RemoteModelInterface.prototype.getId = function getId(compId) {
    return _lodash2.default.cloneDeep(_lodash2.default.get(this._model.components, [compId, ID]));
  };

  RemoteModelInterface.prototype.getEventTypes = function getEventTypes() {
    return _lodash2.default.cloneDeep(this._model.EventTypes);
  };

  RemoteModelInterface.prototype.isLivePreviewMode = function isLivePreviewMode() {
    return this.livePreviewMode;
  };

  RemoteModelInterface.prototype.getPublicAPI = function getPublicAPI(compId) {
    var publicApi = _lodash2.default.get(this._model.components, [compId, PUBLIC_API]);
    if (_lodash2.default.isFunction(publicApi)) {
      return publicApi;
    }
    return _lodash2.default.cloneDeep(publicApi);
  };

  RemoteModelInterface.prototype.getCallbackById = function getCallbackById(callbackId, newFormat) {
    var eventHandler = this._model.eventHandlers[callbackId]; // TODO - backward compatibility - remove after SDK next release
    if (newFormat) {
      return eventHandler;
    }
    return _lodash2.default.get(eventHandler, 'callback');
  };

  RemoteModelInterface.prototype.getParent = function getParent(compId) {
    return _lodash2.default.cloneDeep(_lodash2.default.get(this._model.components, [compId, PARENT]));
  };

  RemoteModelInterface.prototype.getChildren = function getChildren(parentId) {
    return _lodash2.default.clone(_lodash2.default.get(this._model.components, [parentId, CHILDREN]));
  };

  RemoteModelInterface.prototype.getSiteStructure = function getSiteStructure() {
    return _lodash2.default.cloneDeep(this._model.siteStructure);
  };

  RemoteModelInterface.prototype.getPageData = function getPageData() {
    return _lodash2.default.cloneDeep(this._model.pageData);
  };

  RemoteModelInterface.prototype.getFullDataWithOverrides = function getFullDataWithOverrides(compId) {
    return _lodash2.default.defaults(this.getData(compId), getFullData.call(this, compId));
  };

  RemoteModelInterface.prototype.isGhostComponent = function isGhostComponent(compId) {
    return _lodash2.default.get(this._model.components, [compId, IS_GHOST]);
  };

  RemoteModelInterface.prototype.jsonWithoutWixCodeComps = function jsonWithoutWixCodeComps() {
    var compsToKeep = (0, _lodash2.default)(this._model.components).toPairs().filter(function (_ref) {
      var comp = _ref[1];
      return _lodash2.default.get(comp, 'data.applicationId');
    }).map(function (_ref2) {
      var key = _ref2[0];
      return key;
    }).value();

    return _lodash2.default.defaults({ components: _lodash2.default.pick(this._model.components, compsToKeep) }, this._model);
  };

  RemoteModelInterface.prototype.cleanModelForLivePreview = function cleanModelForLivePreview() {
    (0, _lodash2.default)(this._model.components).filter(['type', 'wysiwyg.viewer.components.Repeater']).map('data').forEach(function (dataItem) {
      if (!_lodash2.default.isEmpty(dataItem.items)) {
        (0, _wSpyLog.wSpyLog)('livepreview', ['cleaning RMI repeater items', dataItem.items]);
        dataItem.items = [];
      }
    });
  };

  RemoteModelInterface.prototype.getCurrentScope = function getCurrentScope() {
    return _lodash2.default.clone(_lodash2.default.get(this._model.scopesHierarchy, 0));
  };

  RemoteModelInterface.prototype.getAppPublicAPI = function getAppPublicAPI(appDefId) {
    return _lodash2.default.get(this._model.appApis, appDefId);
  };

  //Setters

  RemoteModelInterface.prototype.setDataWithoutUpdate = function setDataWithoutUpdate(compId, partialData) {
    var checkForDifference = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    set.call(this, compId, DATA, partialData, checkForDifference);
  };

  RemoteModelInterface.prototype.setData = function setData(compId, partialData) {
    var checkForDifference = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    set.call(this, compId, DATA, partialData, checkForDifference, this._onUpdateCallback);
  };

  RemoteModelInterface.prototype.setStyle = function setStyle(compId, partialData, callback) {
    var _this2 = this;

    var checkForDifference = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    set.call(this, compId, STYLE, partialData, checkForDifference, function (_ref3) {
      var compId = _ref3.compId,
          type = _ref3.type,
          data = _ref3.data;

      _this2._onUpdateCallback.call(_this2, { compId: compId, type: type, data: data, appDefinitionId: _this2.getAppDefinitionId(), controllerId: _this2.controllerId, callback: callback });
    });
  };

  RemoteModelInterface.prototype.setDesign = function setDesign(compId, partialData) {
    var checkForDifference = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    set.call(this, compId, DESIGN, partialData, checkForDifference, this._onUpdateCallback);
  };

  RemoteModelInterface.prototype.setProps = function setProps(compId, partialProps, callback) {
    var _this3 = this;

    var checkForDifference = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    set.call(this, compId, PROPS, partialProps, checkForDifference, function (_ref4) {
      var compId = _ref4.compId,
          type = _ref4.type,
          data = _ref4.data;

      if (compId && type && data) {
        _this3._onUpdateCallback.call(_this3, {
          compId: compId,
          type: type,
          data: data,
          appDefinitionId: _this3.getAppDefinitionId(),
          controllerId: _this3.controllerId,
          callback: callback
        });
      }
    });
  };

  RemoteModelInterface.prototype.setLayout = function setLayout(compId, partialLayout) {
    var checkForDifference = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    set.call(this, compId, LAYOUT, partialLayout, checkForDifference, this._onUpdateCallback);
  };

  RemoteModelInterface.prototype.setPublicAPI = function setPublicAPI(compId, api) {
    var comp = _lodash2.default.get(this._model.components, compId);
    if (comp) {
      comp[PUBLIC_API] = api;
    }
  };

  RemoteModelInterface.prototype.executeCompBehavior = function executeCompBehavior(compId, behaviorName, params, callback) {
    executeBehavior.call(this, 'comp', behaviorName, params, compId, callback);
  };

  RemoteModelInterface.prototype.executeAnimation = function executeAnimation(compId, animationName, params, callback) {
    executeBehavior.call(this, 'animation', animationName, params, compId, callback);
  };

  RemoteModelInterface.prototype.setUpdateCallback = function setUpdateCallback(onUpdateCallback) {
    this._onUpdateCallback = onUpdateCallback;
  };

  RemoteModelInterface.prototype.registerEvent = function registerEvent(contextId, compId, eventType, controllerId, callback) {
    if (this.isGhostComponent(compId)) {
      return;
    }

    if (this.isLivePreviewMode()) {
      return;
    }

    var callbackId = void 0;
    if (_lodash2.default.isFunction(callback)) {
      callbackId = this.registerEventCallback({ callback: callback, contextId: contextId, controllerId: controllerId });
    } else {
      callbackId = callback;
    }

    var eventDescriptor = {
      contextId: contextId,
      eventType: eventType,
      callbackId: callbackId
    };
    var component = _lodash2.default.get(this._model, ['components', compId]);
    if (component !== undefined) {
      this._hooksManager.executeHooksAndUpdateValue(this, 'registerEvent', component.type, compId, [contextId, eventType, controllerId, callbackId]);
      component.events.push({ eventType: eventType, callbackId: callbackId });
      if (this._transaction._onTransaction) {
        addItemToTransactionQueue.call(this, compId, 'registerEvent', eventDescriptor);
        return;
      }
      if (_lodash2.default.isFunction(this._onUpdateCallback)) {
        this._onUpdateCallback({ compId: compId, type: 'registerEvent', data: eventDescriptor, appDefinitionId: this.getAppDefinitionId(), controllerId: this.controllerId });
      }
    }
  };

  RemoteModelInterface.prototype.getEventCallbackIds = function getEventCallbackIds(compId, eventType) {
    var component = _lodash2.default.get(this._model, ['components', compId]);
    if (component !== undefined) {
      var events = _lodash2.default.filter(component.events, { eventType: eventType });
      return _lodash2.default.map(events, 'callbackId');
    }
  };

  RemoteModelInterface.prototype.toJson = function toJson() {
    return this._model;
  };

  RemoteModelInterface.prototype.setRenderType = function setRenderType(rendererType) {
    this._model.renderType = rendererType;
  };

  RemoteModelInterface.prototype.setAppPublicAPI = function setAppPublicAPI(appDefId, api) {
    this._model.appApis[appDefId] = api;
  };

  //General

  RemoteModelInterface.prototype.getComponents = function getComponents() {
    var templateComponents = {};
    for (var compId in this._model.components) {
      //eslint-disable-line guard-for-in
      if (!modelUtils.isTemplateComp(this._model, compId)) {
        templateComponents[compId] = this.getComp(compId);
      }
    }

    return templateComponents;
  };

  RemoteModelInterface.prototype.getCompToTypeMap = function getCompToTypeMap() {
    var templateComponents = {};
    for (var compId in this._model.components) {
      //eslint-disable-line guard-for-in
      if (!modelUtils.isTemplateComp(this._model, compId)) {
        templateComponents[compId] = this.getType(compId);
      }
    }

    return templateComponents;
  };

  RemoteModelInterface.prototype.getScopedRMI = function getScopedRMI(controllerId) {
    var scopedRMI = new this.constructor(this._model, this._onUpdateCallback, {
      _hooksManager: this._hooksManager,
      _transaction: this._transaction
    });
    scopedRMI.controllerId = controllerId;
    scopedRMI.getCompIdsFromRole = scopedRMI.getCompIdsFromRole.bind(scopedRMI, controllerId);
    scopedRMI.getCompIdsFromType = scopedRMI.getCompIdsFromType.bind(scopedRMI, controllerId);
    scopedRMI.getAppDefinitionId = scopedRMI.getAppDefinitionId.bind(scopedRMI, controllerId);
    scopedRMI.getAllCompIdsInScope = scopedRMI.getAllCompIdsInScope.bind(scopedRMI, controllerId);
    scopedRMI.getConfig = scopedRMI.getConfig.bind(scopedRMI, controllerId);
    return scopedRMI;
  };

  RemoteModelInterface.prototype.getNestedScopedRMI = function getNestedScopedRMI(model) {
    return new this.constructor(model || this._model, this._onUpdateCallback, {
      _hooksManager: this._hooksManager,
      _transaction: this._transaction
    });
  };

  RemoteModelInterface.prototype.getCompIdsFromType = function getCompIdsFromType(controllerId, type, onlyNested) {
    var components = _lodash2.default.get(this._model.connections, controllerId);
    return getIdsFromType.call(this, components, controllerId, type, onlyNested);
  };

  RemoteModelInterface.prototype.getCompIdsFromRole = function getCompIdsFromRole(controllerId, role, onlyNested) {
    var connectionConfigs = _lodash2.default.get(this._model.connections, [controllerId, role]);
    return getIdsFromRole.call(this, connectionConfigs, controllerId, role, onlyNested);
  };

  RemoteModelInterface.prototype.getAllCompIdsInScope = function getAllCompIdsInScope(controllerId) {
    return _lodash2.default.reduce(_lodash2.default.get(this._model.connections, [controllerId]), function (result, value) {
      _lodash2.default.map(_lodash2.default.keys(value), function (compId) {
        return result.push(compId);
      });
      return result;
    }, []);
  };

  RemoteModelInterface.prototype.getConfig = function getConfig(controllerId, compId, role, onlyNested) {
    var connectionConfigs = _lodash2.default.get(this._model.connections, [controllerId, role]);
    var acceptedScopes = getCurrentScopeId.call(this, onlyNested);

    return connectionConfigs && connectionConfigs.hasOwnProperty(compId) && _lodash2.default.includes(acceptedScopes, _lodash2.default.get(this._model.componentsScopes, compId)) ? connectionConfigs[compId] : {};
  };

  RemoteModelInterface.prototype.updateModel = function updateModel(modelUpdates) {
    for (var compId in modelUpdates) {
      //eslint-disable-line guard-for-in
      var defaultComp = generateDefaultCompStructure();
      var comp = _lodash2.default.get(this._model.components, compId);
      var compUpdates = modelUpdates[compId];
      if (!comp) {
        continue;
      }

      for (var keyToUpdate in compUpdates) {
        if (!_lodash2.default.has(comp, keyToUpdate)) {
          continue;
        }
        if (_lodash2.default.isObject(comp[keyToUpdate])) {
          if (compUpdates[keyToUpdate]) {
            _lodash2.default.assign(comp[keyToUpdate], compUpdates[keyToUpdate]);
          } else {
            // for modes change, when key should be initial to default value
            comp[keyToUpdate] = defaultComp[keyToUpdate];
          }
        } else {
          comp[keyToUpdate] = compUpdates[keyToUpdate];
        }
      }
    }
  };

  RemoteModelInterface.prototype.getScopedRMIByCompId = function getScopedRMIByCompId(compId) {
    var itemContext = this.getRepeaterItemContext(compId);
    if (_lodash2.default.isEmpty(itemContext)) {
      return this;
    }

    var displayedRoot = itemContext.displayedRoot,
        itemId = itemContext.itemId;


    return this.getScopedRMIForRepeaterItem(displayedRoot, itemId);
  };

  RemoteModelInterface.prototype.getScopedRMIForRepeaterItem = function getScopedRMIForRepeaterItem(repeaterId, itemId) {
    var model = _lodash2.default.clone(this._model);
    var templateCompIds = modelUtils.getAllCompsUnderRoot(model, repeaterId);
    var itemCompIds = templateCompIds.map(function (compId) {
      return _repeaterUtils2.default.structure.getUniqueDisplayedId(compId, itemId);
    });

    model.scopesHierarchy = _lodash2.default.clone(model.scopesHierarchy);
    model.scopesHierarchy.unshift({ type: COMPONENT_SCOPE, id: repeaterId, compId: repeaterId, additionalData: { itemId: itemId } });

    model.componentsScopes = _lodash2.default.clone(model.componentsScopes);
    templateCompIds.forEach(function (templateCompId) {
      return model.componentsScopes[templateCompId] = null;
    });
    itemCompIds.forEach(function (itemCompId) {
      return model.componentsScopes[itemCompId] = repeaterId;
    }); //eslint-disable-line no-return-assign

    return this.getNestedScopedRMI(model);
  };

  RemoteModelInterface.prototype.getRepeaterItemContext = function getRepeaterItemContext(compId) {
    var displayedRoot = _lodash2.default.get(this._model.components, [compId, DISPLAYED_ROOT]);

    if (!displayedRoot) {
      return {};
    }

    var itemId = _repeaterUtils2.default.structure.getItemId(compId);
    return { displayedRoot: displayedRoot, itemId: itemId };
  };

  RemoteModelInterface.prototype.getScopeByCompId = function getScopeByCompId(compId) {
    var _getRepeaterItemConte = this.getRepeaterItemContext(compId),
        displayedRoot = _getRepeaterItemConte.displayedRoot,
        itemId = _getRepeaterItemConte.itemId;

    if (!displayedRoot) {
      return { type: GLOBAL_SCOPE, id: GLOBAL_SCOPE, additionalData: {} };
    }

    return { type: COMPONENT_SCOPE, id: displayedRoot, compId: displayedRoot, additionalData: { itemId: itemId } };
  };

  RemoteModelInterface.prototype.isRepeaterScope = function isRepeaterScope(scope) {
    if (_lodash2.default.get(scope, 'type') === COMPONENT_SCOPE && !_lodash2.default.isEmpty(_lodash2.default.get(scope, 'additionalData.itemId'))) {
      return true;
    }

    return false;
  };

  RemoteModelInterface.prototype.startTransaction = function startTransaction() {
    this._transaction._onTransaction = true;
  };

  RemoteModelInterface.prototype.endTransaction = function endTransaction() {
    if (this._onUpdateCallback && !_lodash2.default.isEmpty(this._transaction._transactionData)) {
      this._onUpdateCallback({ type: 'executeBatch', data: this._transaction._transactionData, appDefinitionId: this.getAppDefinitionId(), controllerId: this.controllerId });
    }
    this._transaction._onTransaction = false;
    this._transaction._transactionData = {};
  };

  RemoteModelInterface.prototype.setBatchData = function setBatchData(newData) {
    var _this4 = this;

    _lodash2.default.forEach(newData, function (dataByProperty, compId) {
      _lodash2.default.forEach(dataByProperty, function (partialData, propertyType) {
        switch (propertyType) {
          case 'registerEvent':
            _lodash2.default.forEach(partialData, function (eventDescriptor) {
              _this4.registerEvent.call(_this4, eventDescriptor.contextId, compId, eventDescriptor.eventType, eventDescriptor.controllerId, eventDescriptor.callbackId);
            });
            break;
          default:
            var funcName = 'set' + _lodash2.default.startCase(propertyType);
            _this4[funcName].call(_this4, compId, partialData);
            break;
        }
      });
    });
  };

  RemoteModelInterface.prototype.registerHook = function registerHook(hookName, compType, callback) {
    this._hooksManager.registerHook(hookName, compType, callback);
  };

  RemoteModelInterface.prototype.getHooks = function getHooks() {
    return this._hooksManager.HOOKS;
  };

  RemoteModelInterface.prototype.updateWidgetProperties = function updateWidgetProperties(widgetProperties) {
    this._model.appStudioWidgetData.properties = widgetProperties;
  };

  RemoteModelInterface.prototype.getWidgetProperties = function getWidgetProperties() {
    return this._model.appStudioWidgetData.properties;
  };

  RemoteModelInterface.prototype.getAppDefinitionId = function getAppDefinitionId(controllerId) {
    var compId = this.getCompIdByDataQuery(controllerId);
    return _lodash2.default.get(this._model, ['components', compId, 'data', 'applicationId']);
  };

  RemoteModelInterface.prototype.getCompIdByDataQuery = function getCompIdByDataQuery(compDataQuery) {
    return _lodash2.default.findKey(this._model.components, [FULL_DATA + '.' + ID, compDataQuery]);
  };

  RemoteModelInterface.prototype.registerEventCallback = function registerEventCallback(_ref5) {
    var callback = _ref5.callback,
        contextId = _ref5.contextId,
        controllerId = _ref5.controllerId,
        overrideCallbackId = _ref5.overrideCallbackId;

    if (!_lodash2.default.isFunction(callback)) {
      return;
    }
    var callbackId = overrideCallbackId || guid();
    this._model.eventHandlers[callbackId] = { callback: callback, contextId: contextId, controllerId: controllerId };
    return callbackId;
  };

  RemoteModelInterface.prototype.isBolt = function isBolt() {
    return this._model.renderType === 'bolt';
  };

  _createClass(RemoteModelInterface, [{
    key: 'seoTitle',
    get: function get() {
      return this._model.seo.title;
    },
    set: function set(title) {
      this._model.seo.title = title;
    }
  }, {
    key: 'seoStructuredData',
    get: function get() {
      return _lodash2.default.cloneDeep(this._model.seo.structuredData);
    },
    set: function set(structuredData) {
      this._model.seo.structuredData = structuredData;
    }
  }, {
    key: 'seoMetaTags',
    get: function get() {
      return _lodash2.default.cloneDeep(this._model.seo.metaTags);
    },
    set: function set(metaTags) {
      this._model.seo.metaTags = metaTags;
    }
  }, {
    key: 'seoLinks',
    get: function get() {
      return _lodash2.default.cloneDeep(this._model.seo.links);
    },
    set: function set(links) {
      this._model.seo.links = links;
    }
  }, {
    key: 'seoStatusCode',
    get: function get() {
      return this._model.seo.statusCode;
    },
    set: function set(statusCode) {
      this._model.seo.statusCode = statusCode;
    }
  }]);

  return RemoteModelInterface;
}();

function getCurrentScopeId(onlyNested) {
  return onlyNested ? _lodash2.default.get(this._model.scopesHierarchy, '0.id') : _lodash2.default.map(this._model.scopesHierarchy, function (scopeHierarchy) {
    return _lodash2.default.get(scopeHierarchy, 'id');
  });
}

function generateDefaultCompStructure() {
  var _ref6;

  return _ref6 = {}, _ref6[PARENT] = null, _ref6[STATE] = {}, _ref6[TYPE] = null, _ref6[DATA] = {}, _ref6[FULL_DATA] = {}, _ref6[DESIGN] = {}, _ref6[PROPS] = {}, _ref6[LAYOUT] = {}, _ref6[EVENTS] = [], _ref6[IS_DISPLAYED] = false, _ref6[IS_GHOST] = false, _ref6[ID] = null, _ref6[PUBLIC_API] = {}, _ref6[STYLE] = {}, _ref6[CHILDREN] = [], _ref6[DISPLAYED_ONLY_COMPONENTS] = [], _ref6[DISPLAYED_ROOT] = null, _ref6;
}

function getFullData(compId) {
  return _lodash2.default.cloneDeep(_lodash2.default.get(this._model.components, [compId, FULL_DATA]));
}

function executeBehavior(behaviorType, behaviorName, params, compId, callback) {
  if (this.isGhostComponent(compId)) {
    return;
  }

  var requiresDom = _lodash2.default.get(params, 'requiresDom', { compId: compId });
  params = requiresDom ? params : _lodash2.default.omit(params, ['requiresDom']);

  var behavior = {
    type: behaviorType,
    name: behaviorName,
    targetId: compId,
    requiresDom: requiresDom,
    params: params
  };

  if (this._onUpdateCallback) {
    this._onUpdateCallback({ compId: compId, type: BEHAVIOR, data: behavior, appDefinitionId: this.getAppDefinitionId(), controllerId: this.controllerId, callback: callback });
  }
}

//Utility

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function set(compId, property, partial, checkForDifference, onUpdateCallback) {
  var comp = _lodash2.default.get(this._model, ['components', compId]);
  if (!comp) {
    return;
  }

  this._hooksManager.executeHooksAndUpdateValue(this, property, comp.type, compId, [partial, onUpdateCallback]);
  if (comp[IS_DISPLAYED]) {
    var currentData = comp[property];
    var newCompData = _lodash2.default.defaults({}, partial, currentData);
    if (this.isBolt() && checkForDifference && _lodash2.default.isEqual(newCompData, currentData)) {
      return;
    }
    this._model.components[compId][property] = newCompData;
  }
  if (this.isBolt() && this.isGhostComponent(compId)) {
    return;
  }
  if (onUpdateCallback) {
    if (this._transaction._onTransaction) {
      addItemToTransactionQueue.call(this, compId, property, partial);
    } else {
      onUpdateCallback({ compId: compId, type: property, data: partial, appDefinitionId: this.getAppDefinitionId(), controllerId: this.controllerId });
    }
  }
}

function addItemToTransactionQueue(compId, property, partial) {
  var transactionData = this._transaction._transactionData;
  if (!transactionData[compId]) {
    transactionData[compId] = {};
  }

  if (property === 'registerEvent') {
    if (!transactionData[compId][property]) {
      transactionData[compId][property] = [];
    }
    transactionData[compId][property].push(partial);
    return;
  }
  if (!transactionData[compId][property]) {
    transactionData[compId][property] = {};
  }
  _lodash2.default.assign(transactionData[compId][property], partial);
}

function getIdsFromType(components, controllerId, type, onlyNested) {
  var compIds = _lodash2.default.flatMap(components, Object.keys);
  var comps = [];
  var acceptedScopes = getCurrentScopeId.call(this, onlyNested);

  compIds.forEach(function (compId) {
    var compType = this.getType(compId);
    if (compType === type && _lodash2.default.includes(acceptedScopes, _lodash2.default.get(this._model.componentsScopes, compId))) {
      comps.push(compId);
    }
  }, this);
  return comps;
}

function getIdsFromRole(connectionConfigs, controllerId, type, onlyNested) {
  var _this5 = this;

  var acceptedScopes = getCurrentScopeId.call(this, onlyNested);
  var compIds = connectionConfigs ? Object.keys(connectionConfigs) : [];
  return compIds.filter(function (compId) {
    return _lodash2.default.includes(acceptedScopes, _lodash2.default.get(_this5._model.componentsScopes, compId));
  });
}

function addGhostComponent(ghostId, ghost) {
  var ghostComp = _lodash2.default.cloneDeep(ghost);
  ghostComp[IS_GHOST] = true;
  ghostComp[STATE] = {};

  this._model.components[ghostId] = ghostComp;
  this._model.componentsScopes[ghostId] = GLOBAL_SCOPE;
}
//# sourceMappingURL=RemoteModelInterface.js.map